import React from 'react'
import { useTranslation } from 'react-i18next'
import { UserRound } from 'lucide-react'
import { tr } from 'i18n'
import './DriverWithoutTransport.scss'

export default function DriverWithoutTransport() {
  useTranslation()
  return <section className="driver-without-transport" role="status">
    <UserRound size={25} aria-hidden="true" /><div><h3>{tr('Водитель без транспорта')}</h3>
      <p>{tr('Вы освобождены от автомобиля. Администрация может назначить вас на другой транспорт. История ваших погрузок сохранена.')}</p></div>
  </section>
}
